import { DocumentsUploadBrokerageFirmModule } from '../DocumentsUploadBrokerageFirmModule/DocumentsUploadBrokerageFirmModule';
import { useAssertedParams } from '@folio/lib';
import { useExpectedUploadedDocuments } from '@folio/utils/useExpectedUploadedDocuments';
import { useTranslation } from 'react-i18next';

type BrokerageFirmUploadDocumentsProps = {
  hiddenDocumentCategories?: string[];
};

// @debt: this module is used in uniq projects and should be able to validate the documents uploaded by the brokerage firm
export function BrokerageFirmUploadDocumentsModule({
  hiddenDocumentCategories,
}: BrokerageFirmUploadDocumentsProps) {
  const { t } = useTranslation();
  const { brokerageFirmId } = useAssertedParams();
  const { data: brokerageFirmDocumentsList } = useExpectedUploadedDocuments({ brokerageFirmId });

  const documentsLists =
    hiddenDocumentCategories && brokerageFirmDocumentsList
      ? brokerageFirmDocumentsList.filter(
          document => !hiddenDocumentCategories.includes(document.category),
        )
      : (brokerageFirmDocumentsList ?? []);

  return (
    <DocumentsUploadBrokerageFirmModule
      title={t('brokerageFirmDocuments.title')}
      documentsLists={documentsLists ?? []}
    />
  );
}
